import React from 'react';
import { Link } from 'react-router-dom';
import ill_washing_machines from '../images/ill-washing-2-machines.png';
import ill_okay from '../images/ill-ok.png';
import PortalButton from '../components/Button';
function Thankyou1() {
  return (
    <main className="bg-white">
      <div className="relative md:flex">
        {/* <div
          className="hidden md:block  top-0 bottom-0 left-0 md:w-1/2"
          aria-hidden="true">
          <img
            className="object-cover object-center h-full"
            src={ill_washing_machines}
            alt="Authentication"
          />
        </div> */}
        {/* <div className="text-center px-4 py-2 md:py-auto md:w-1/2 justify-center">
          <div className="inline-flex">
            <img
              src={ill_washing_machines}
              className="px-24"
              alt="404 illustration"
            />
          </div>
        </div> */}
        {/* <div className="flex items-center md:w-1/2">
          <div className="py-4">01</div>
        </div> */}
        <div className="hidden lgg:grid grid-cols-1 gap-2 place-items-center  w-full lgg:w-1/2 lgg:bg-statustext-600 rounded-r-[70px] lgg:h-[900px]">
          <div className="inline-flex">
            <img src={ill_washing_machines} className="px-24 z-10" alt="404 illustration" />
            <div className="bg-statustext-800 absolute bottom-0 w-1/2 h-1/2 rounded-t-full"></div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-2 place-items-center w-full lgg:w-1/2 lgg:h-[900px]">
          <div className=" inline-flex">
            <div className="max-w-md mx-auto px-2 py-8">
              <div className="text-center lgg:text-left text-lg">
                <div className="flex justify-center lgg:justify-start">
                  <img className="w-16" src={ill_okay} />
                </div>
                <div className="text-xl lgg:text-3xl font-semibold text-portal-600 py-4 ">Thanks You for Accepting!</div>
                <div className="font-semibold text-md lgg:text-xl py-2">We’re happy to have you on board!</div>
                <div className="pb-1 text-md lgg:text-xl py-2">
                  We’ll send you onboarding information <br />
                  in 24-48 hours.
                </div>
                <div className="pb-1 text-md lgg:text-xl py-2">
                  Don’t hestiate to <span className="text-portal-300 font-semibold">contact us</span> if you have any questions or
                  concerns.
                </div>
                {/* <div className="flex justify-center mt-10">
                  <div className="w-1/3">
                    <PortalButton
                      variant="primary"
                      text="Done"
                      onClick={() =>
                        setOfferAcceptOpen(!OfferAcceptOpen)
                      }></PortalButton>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="lgg:hidden grid grid-cols-1 gap-2 place-items-center w-full lgg:w-1/2 ">
          <div className="inline-flex">
            <img src={ill_washing_machines} className="px-12 py-8" alt="404 illustration" />
          </div>
        </div>
      </div>
    </main>
  );
}

export default Thankyou1;
